import React from 'react';
import { GroupedListData } from 'modules/analytics/common/types';
import { sumScoreField } from 'modules/analytics/common/utils';
import { gpScore } from 'modules/analytics/survey/utils/survey-scores';
import SurveyRateCell from 'modules/survey/management/components/SurveyRateCell/SurveyRateCell';

const GpScoreCell = ({ data }: { data: GroupedListData }) => {
  const veryUnsatisfiedTotal = data.isGroup
    ? sumScoreField(data?.scoreData || [], 'veryUnsatisfiedTotal')
    : data.veryUnsatisfiedTotal;
  const total = data.isGroup ? sumScoreField(data?.scoreData || [], 'total') : data.total;
  const satisfiedTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'satisfiedTotal') : data.satisfiedTotal;
  const unsatisfiedTotal = data.isGroup
    ? sumScoreField(data?.scoreData || [], 'unsatisfiedTotal')
    : data.unsatisfiedTotal;
  const verySatisfiedTotal = data.isGroup
    ? sumScoreField(data?.scoreData || [], 'verySatisfiedTotal')
    : data.verySatisfiedTotal;
  const neutralTotal = data.isGroup ? sumScoreField(data?.scoreData || [], 'neutralTotal') : data.neutralTotal;

  return (
    <SurveyRateCell
      key={data._id}
      number={gpScore({
        total,
        veryUnsatisfiedTotal,
        satisfiedTotal,
        unsatisfiedTotal,
        verySatisfiedTotal,
        neutralTotal,
      })}
    />
  );
};

export default GpScoreCell;
